export const noOp = () => {};

export const scrollToTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
}

export const splitFacets = (facets) => {
    //Only splits on commas not between double quotes.
    return facets.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
}

// check whether space or double quotation marks are present
export const containsSpaceOrDoubleQuote = (val) => val && (/\s/g.test(val) || val?.toString()?.includes('"'));

//check whether special character for facets is present
export const containsSpecialCharacterForFacets = (val) => val && /[^a-zA-Z0-9-]/.test(val);

// escape double quotation marks
export const escapeDoubleQuotes = (optionValue) => optionValue?.toString()?.replace(/"/g, '\\"');


/**
 * Filters the sort options based on the hideLoggedOutPricing parameter.
 * @param {Array} options - The array of sort options to filter.
 * @param {boolean} hideLoggedOutPricing - A flag to determine if certain options should be hidden.
 * @returns {Array} - The filtered array of sort options based on the hideLoggedOutPricing parameter.
 */
export const filterSortOptions = (options, hideLoggedOutPricing) => {
  if (hideLoggedOutPricing) {
    return options.filter(option => option.value !== 'price_descending' && option.value !== 'price_ascending');
  } else {
    return options;
  }
};